const Navbar = () => {
    return (  
      <header className="header_main">
      <div className="container">
         <nav className="navbar navbar-expand-sm  navbar-dark real-navbar">
           {/* <!-- Brand --> */}
           <a className="navbar-brand logo" href="#"><span>UNIVERSAL</span> SPACE STATION</a>
           {/* <!-- Toggler/collapsibe Button --> */}
           <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
             <span className="navbar-toggler-icon"></span>
           </button>

           {/* <!-- Navbar links --> */}
           <div className="collapse navbar-collapse" id="collapsibleNavbar">
             <ul className="navbar-nav">
               <li className="nav-item active">
                 <a className="nav-link active" href="#home">Home</a>
               </li>
               <li className="nav-item">
                 <a className="nav-link" href="#intro">About</a>
               </li>
               <li className="nav-item">
                 <a className="nav-link" href="#roadmap">Roadmap</a>
               </li>
               <li className="nav-item">
                 <a className="nav-link" href="#team">Team</a>
               </li>
               <li className="nav-item">
                 <a className="nav-link" href="#faq">FAQ</a>
               </li>
               <li className="nav-item whitepaper">
                 <a className="nav-link" href="images/WhitePaper.pdf" target="_blank">WhitePaper</a>
               </li>
             </ul>
           </div>
         </nav>
         {/* <!--Mobile whitepaper--> */}
          <div className="whitepapaer">
              <nav className="navbar navbar-expand-sm  navbar-dark mobile-whitepaper-navbar">
           {/* <!-- Mobile WHitepaper links --> */}
           <div className="mobile_whitepaper" id="">
               <a className="navbar-brand logo" href="#"><span>UNIVERSAL</span> SPACE STATION</a>
             <ul className="navbar-nav">
               <li className="nav-item whitepaper">
                 <a className="nav-link" href="images/WhitePaper.pdf" target="_blank">WhitePaper</a>
               </li>
             </ul>
           </div>
         </nav>
          </div>
      </div>
   </header>
    );
}
 
export default Navbar;